angular.module('MyHippoProducer.Controllers').directive('optionalOtherStructuresSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/optional-other-structures/optional-other-structures.html',
    };
});
